export default __webpack_public_path__ + "static/media/portfolio-103.f6647cef.jpg";